<template>
  <transition name="fade">
    <div class="loading-wrapper" :class=" isAuth || !authLoading ? 'loading-background' : ''">
      <div class="floatingCirclesG">
        <div class="f_circleG" id="frotateG_01"></div>
        <div class="f_circleG" id="frotateG_02"></div>
        <div class="f_circleG" id="frotateG_03"></div>
        <div class="f_circleG" id="frotateG_04"></div>
        <div class="f_circleG" id="frotateG_05"></div>
        <div class="f_circleG" id="frotateG_06"></div>
        <div class="f_circleG" id="frotateG_07"></div>
        <div class="f_circleG" id="frotateG_08"></div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>

import {useGetAuth} from "@/composable/controller/useUser";
import {computed} from "vue";

const props = defineProps({
  isAuth: {
    type: Boolean,
    default: false
  }
});

const {authLoading} = useGetAuth();

</script>

<style scoped>

.loading-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000;
}

.loading-background {
  background-color: rgba(200, 200, 200, 0.8);
}

.floatingCirclesG {
  position: relative;
  width: 144px;
  height: 144px;
  transform: scale(0.6);
}

.f_circleG {
  position: absolute;
  background-color: rgb(255, 255, 255);
  height: 26px;
  width: 26px;
  border-radius: 14px;
  animation-name: f_fadeG;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-direction: normal;
}

#frotateG_01 { left: 0; top: 59px; animation-delay: 0.45s; }
#frotateG_02 { left: 17px; top: 17px; animation-delay: 0.6s; }
#frotateG_03 { left: 59px; top: 0; animation-delay: 0.75s; }
#frotateG_04 { right: 17px; top: 17px; animation-delay: 0.9s; }
#frotateG_05 { right: 0; top: 59px; animation-delay: 1.05s; }
#frotateG_06 { right: 17px; bottom: 17px; animation-delay: 1.2s; }
#frotateG_07 { left: 59px; bottom: 0; animation-delay: 1.35s; }
#frotateG_08 { left: 17px; bottom: 17px; animation-delay: 1.5s; }

@keyframes f_fadeG {
  0% {
    background-color: #004680;
  }
  100% {
    background-color: rgb(255, 255, 255);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


</style>
